export default __webpack_public_path__ + "static/media/coin.e3e91821.webp";